(function () {
    'use strict';

    const form = document.getElementById('newsletter-form');
    if (!form) return;

    const firstnameInput  = form.querySelector('[name="firstname"]');
    const emailInput      = form.querySelector('[name="email"]');
    const firstnameError  = document.getElementById('newsletter-firstname-error');
    const emailError      = document.getElementById('newsletter-email-error');
    const errorBanner     = document.getElementById('newsletter-error-banner');
    const formWrap        = document.getElementById('newsletter-form-wrap');
    const thankyou        = document.getElementById('newsletter-thankyou');
    const submitBtn       = document.getElementById('newsletter-submit');

    function isValidEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
    }

    function clearErrors() {
        firstnameInput.classList.remove('newsletter__input--error');
        emailInput.classList.remove('newsletter__input--error');
        firstnameError.classList.remove('newsletter__field-error--visible');
        emailError.classList.remove('newsletter__field-error--visible');
        errorBanner.classList.remove('newsletter__error-banner--visible');
    }

    function showFieldError(input, errorEl, message) {
        input.classList.add('newsletter__input--error');
        errorEl.textContent = message;
        errorEl.classList.add('newsletter__field-error--visible');
    }

    function validate() {
        var valid = true;

        if (!firstnameInput.value.trim()) {
            showFieldError(firstnameInput, firstnameError, 'Please enter your first name.');
            valid = false;
        }

        if (!emailInput.value.trim()) {
            showFieldError(emailInput, emailError, 'Please enter your email address.');
            valid = false;
        } else if (!isValidEmail(emailInput.value)) {
            showFieldError(emailInput, emailError, 'Please enter a valid email address.');
            valid = false;
        }

        return valid;
    }

    form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearErrors();

        if (!validate()) return;

        submitBtn.disabled = true;
        submitBtn.textContent = 'Subscribing\u2026';

        fetch('https://cmcalimited.activehosted.com/proc.php', {
            method: 'POST',
            body: new URLSearchParams(new FormData(form)),
            mode: 'no-cors'
        })
        .then(function () {
            form.style.display = 'none';
            thankyou.classList.add('newsletter__thankyou--visible');
        })
        .catch(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Subscribe';
            errorBanner.textContent = 'Something went wrong. Please try again.';
            errorBanner.classList.add('newsletter__error-banner--visible');
        });
    });
}());
